import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserTypeTableColumnNames,
  fetchAllUserTypes,
  addUserType,
  updateUserType,
  deleteUserTypes,
  activateDeactivateUserType,
} from "./thunk";

const userTypeSlice = createSlice({
  name: "userType", 
  initialState: {
    userTypesList: [], 
    userTypeTableColumnNames: [], 
    loading: false,
    headerload: false,
    error: null,
  },
  reducers: {}, // Removed topic-specific reducers like clearUploadedTopicImageUrl
  extraReducers: (builder) => {
    builder
      // Fetch UserType Table Column Names
      .addCase(fetchUserTypeTableColumnNames.pending, (state) => {
        state.headerload = true;
        state.error = null;
      })
      .addCase(fetchUserTypeTableColumnNames.fulfilled, (state, action) => {
        state.headerload = false;
        state.userTypeTableColumnNames = action.payload; // Changed state property
      })
      .addCase(fetchUserTypeTableColumnNames.rejected, (state, action) => {
        state.headerload = false;
        state.error = action.payload;
      })

      // Fetch All UserTypes
      .addCase(fetchAllUserTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUserTypes.fulfilled, (state, action) => {        
        state.loading = false;
        state.userTypesList = action.payload; // Changed state property
      })
      .addCase(fetchAllUserTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // // Add UserType
      // .addCase(addUserType.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(addUserType.fulfilled, (state, action) => {
      //   // Assuming the API returns the added item or an array with the added item
      //   const addedUserType = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      //   if (addedUserType) {
      //     state.userTypesList.unshift(addedUserType); // Changed state property
      //   }
      // })
      // .addCase(addUserType.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Update UserType
      // .addCase(updateUserType.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(updateUserType.fulfilled, (state, action) => {
      //   // Assuming the API returns the updated item or an array with the updated item
      //   const updatedUserType = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      //   const index = state.userTypesList.findIndex(ut => ut.ID === updatedUserType?.ID); // Changed state property
      //   if (index !== -1) {
      //     state.userTypesList[index] = updatedUserType; // Changed state property
      //   }
      // })
      // .addCase(updateUserType.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Delete UserTypes
      // .addCase(deleteUserTypes.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(deleteUserTypes.fulfilled, (state, action) => {
      //   // Assuming action.payload is an array of { ID: id } objects for deleted items
      //   const deletedIds = action.payload.map((item) => item.ID);
      //   state.userTypesList = state.userTypesList.filter((item) => !deletedIds.includes(item.ID)); // Changed state property
      // })
      // .addCase(deleteUserTypes.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Activate/Deactivate UserType
      // .addCase(activateDeactivateUserType.pending, (state) => {
      //   // No loading indicator for toggle, or a very subtle one if preferred
      //   state.error = null;
      // })
      // .addCase(activateDeactivateUserType.fulfilled, (state, action) => {
      //   const updatedUserType = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      //   const index = state.userTypesList.findIndex(ut => ut.ID === updatedUserType?.ID); // Changed state property
      //   if (index !== -1) {
      //     state.userTypesList[index] = { ...state.userTypesList[index], ...updatedUserType }; // Changed state property
      //   }
      // })
      // .addCase(activateDeactivateUserType.rejected, (state, action) => {
      //   state.error = action.payload;
      // });
  },
});

export default userTypeSlice.reducer;
